import styled from 'styled-components'

export const StyledStableIntro = {
  Wrapper: styled.div`
    width: 100%;
    max-width: 375px;
    min-height: 100%;

    display: flex;
    align-items: center;

    padding: 0 24px;
    margin: 0 auto;
  `,
}
